import { stateDictionaryKey, useDictionary } from '../i18n/context.js';
import type { VariantStateKey } from '../i18n/types.js';

// ---------------------------------------------------------------------------
// State as text. Every variant state renders its label; colour (the
// `chip--*` accent bar) is redundant reinforcement, never the only encoding
// -- visual design spec section 8.1: "The label is always present and
// always sufficient."
// ---------------------------------------------------------------------------

const CHIP_MODIFIER: Record<VariantStateKey, string | null> = {
  draft: null,
  validated: null,
  canceled: null,
  needsReview: 'chip--attention',
  policyCheck: 'chip--attention',
  held: 'chip--attention',
  approved: 'chip--queued',
  scheduled: 'chip--queued',
  publishing: 'chip--publishing',
  published: 'chip--done',
  failed: 'chip--danger',
};

export type StateChipProps = { state: string };

export const StateChip = ({ state }: StateChipProps): React.JSX.Element => {
  const dict = useDictionary();
  const key = stateDictionaryKey(state);
  const modifier = CHIP_MODIFIER[key];
  return <span className={modifier ? `chip ${modifier}` : 'chip'}>{dict.states[key]}</span>;
};
